import { Button, ButtonDiv, ButtonGroup, ButtonIcon } from './Button';
import { Input } from './Input/Input';
import { Link } from './Link';
import { TextArea } from './TextArea/TextArea';

export const V2 = {
  Button,
  ButtonDiv,
  ButtonIcon,
  Link,
  ButtonGroup,
  Input,
  TextArea,
};
